import { environment } from '@/environments/environment'

export default [
  { name: 'getProtocolConfig', url: `${environment.torontoApiUrl}/shippers/{shipper_id}/rules`, method: 'get' },
  { name: 'postProtocolConfig', url: `${environment.torontoApiUrl}/shippers/{shipper_id}/rules`, method: 'put' }
]